import Crud from '../components/Recipe/Crud'
import View from '../components/Recipe/View'

let routes = {
    path: '/recipe',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {            
            path: '/recipe',
            component: Crud
        },
        {
            path: '/recipe/view/:id',
            component: View
        }
    ]        
}


export default routes


// WEBPACK FOOTER //
// ./src/router/recipe.js